<template>
	<li class="time-off-entry-label">
		<img
			v-if="timeOff.externalSystem"
			v-tooltip="iconTooltip"
			class="time-off-entry-label__image"
			:src="iconSrc"
			:alt="iconSrc"
		/>
		{{ label }}{{ addCommaAfterLabel ? ',&nbsp;' : '' }}
	</li>
</template>

<script setup lang="ts">
import { toRefs, computed } from 'vue';
import { ExternalSystemEnum, type TimeOff } from '@/generated/graphql';
import { Assets } from '@/constants/assets';
import { useTranslation } from '@/composables';
import { TimeOffSystemType } from '@/features/Calendar/components/TimeOff';

export type TimeOffEntryLabelProps = {
	timeOff: TimeOff;
	addCommaAfterLabel?: boolean;
};

const props = defineProps<TimeOffEntryLabelProps>();

const { t } = useTranslation();

const { timeOff } = toRefs(props);

const label = computed(() => {
	const { systemName, displayName } = timeOff.value.type;

	if (
		(systemName === TimeOffSystemType.Other ||
			systemName === TimeOffSystemType.ExtraAvailability) &&
		timeOff.value.reason
	) {
		return timeOff.value.reason.trim();
	}

	return displayName;
});

const iconSrc = computed(() => {
	const externalSystem = timeOff.value.externalSystem;

	if (externalSystem === ExternalSystemEnum.BambooHr) {
		return Assets.BAMBOO_HR_LOGO;
	}

	if (externalSystem === ExternalSystemEnum.GoogleCalendar) {
		return Assets.GOOGLE_CALENDAR_LOGO;
	}

	return '';
});

const iconTooltip = computed(() => {
	if (timeOff.value.externalSystem === ExternalSystemEnum.BambooHr) {
		return t('time-off__bamboo-hr-tooltip');
	}

	if (timeOff.value.externalSystem === ExternalSystemEnum.GoogleCalendar) {
		return t('time-off__google-calendar-tooltip');
	}

	return '';
});
</script>

<style lang="scss" scoped>
.time-off-entry-label {
	display: inline-flex;
	line-height: 2rem;
	gap: 0.5rem;
	text-align: left;
	overflow-wrap: break-word;

	&__image {
		height: 2rem;
	}
}
</style>
